import { useQuery } from "@tanstack/react-query";
import { publicApi } from "../../../Api/api";
import DeclarationBannerView from "@/features/declaration-banner/DeclarationBannerView";
import type { ActiveDeclarationBanner } from "@/features/declaration-banner/types";

/**
 * Bandeau d'information piloté depuis l'admin (panne de téléphonie, maintenance…).
 *
 * Route publique : le bandeau doit aussi s'afficher sur la page de connexion.
 * Re-interrogée régulièrement pour qu'un bandeau activé ou retiré dans l'admin
 * arrive sur les onglets déjà ouverts sans rechargement. En cas d'erreur on
 * n'affiche rien : le bandeau ne doit jamais gêner la déclaration.
 */
export default function DeclarationBanner() {
  const { data } = useQuery({
    queryKey: ["declaration-sinistre", "banner"],
    queryFn: async () => {
      const response = await publicApi.get<ActiveDeclarationBanner>("/public/declaration-banner");
      return response.data;
    },
    staleTime: 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    retry: false,
  });

  if (!data?.enabled) return null;

  return <DeclarationBannerView level={data.level} title={data.title} message={data.message} />;
}
